import React, { useState, useEffect, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { Button, Modal, Form, Row, Col, InputGroup } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";
import Tooltip from "@material-ui/core/Tooltip";
import Autocomplete from "@material-ui/lab/Autocomplete";
import * as Admin from "../../../store/ducks/admin.duck";
import { Grid, Paper, TextField, makeStyles, FormControl, MenuItem, Select, InputLabel } from "@material-ui/core";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

const closureReasonMap = {
  1: "Service Complete",
  2: "Transferred to in-centre support",
  3: "Transferred to an external service",
  4: "Discharged from the Medicare Mental Health Centre",
  5: "No longer suitable for telehealth",
  6: "Service did not proceed",
  7: "Consumer disengaged",
  8: "Other",
};

export default function CsClosuresAdmin() {
  const [searchTerm, setSearchTerm] = useState("");
  const csClosuresAdmin = useSelector((state) => state.admin.CsClosuresAdmin);
  // const role = useSelector((state) => state.auth.roleDesc);
  const filters = useSelector((state) => state.admin.Filters);
  const csCentres = useSelector((state) => state.admin.CsCentres);

  const searchCsClosures = (csClosure) => {
    if (
      true &&
      (csClosure.fullname.toLowerCase().search(searchTerm.toLowerCase()) > -1 ||
        csClosure.flagClean.toLowerCase().search(searchTerm.toLowerCase()) > -1 ||
        searchTerm.length === 0) &&
      (filters.clientsClosureStatus === "All" ||
        (filters.clientsClosureStatus === "In Progress" && csClosure.adminClosureStatusclient.status === "In Progress") ||
        (filters.clientsClosureStatus === "Not Started" && csClosure.adminClosureStatusclient.status === "Not Started") ||
        (filters.clientsClosureStatus === "Closed" && csClosure.adminClosureStatusclient.status === "Closed")) &&
      (!filters.csCentre || filters.csCentre === "All" || (filters.csCentre && String(csClosure.centreId) === String(filters.csCentre.id)))
    ) {
      return csClosure;
    }
  };

  const filteredCsClosures = csClosuresAdmin.filter((csClosure) => searchCsClosures(csClosure));
  const dispatch = useDispatch();
  const classes = useStyles();
  useEffect(() => {
    dispatch(Admin.actions.fetchCSClosuresAdmin());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchCsCentres());
  }, [dispatch]);

  function updateAdminClosureStatus(row, newStatus) {
    // console.log("Updating admin closure status for row ", row.id, " to ", newStatus);
    if (row.adminClosureStatus !== newStatus) {
      dispatch(Admin.actions.putCSClosureAdminStatus({ id: row.id, newStatus: newStatus }));
    }
  }

  function setFlag(event, id, flag) {
    if (event.target.value !== flag) {
      dispatch(
        Admin.actions.putClientFlag({
          id: id,
          flag: event.target.value,
          type: "Closure",
        }),
      );
    }
  }

  // CS Information
  // public int? ownerid { get; set; }
  // public string centreId { get; set; }

  const columns = [
    { field: "id", headerName: "ID", width: 100, hide: true },
    {
      field: "fullname",
      headerName: "Name",
      width: 200,
      renderCell: (params) => {
        const link = params.row.clientLink;

        if (!link) {
          return params.value;
        }

        return <a href={link}>{params.value}</a>;
      },
    },
    { field: "email", headerName: "Email", width: 280 },
    { field: "mobilephone", headerName: "Mobile", width: 110 },
    {
      field: "centreName",
      headerName: "Centre Name",
      width: 220,
    },
    {
      field: "closureDate",
      headerName: "Closure Date",
      width: 150,
      valueFormatter: (params) => (params.value ? new Date(params.value).toLocaleDateString() : ""),
    },
    {
      field: "closureReason",
      headerName: "Closure Reason",
      width: 200,
      valueGetter: (params) => closureReasonMap[params.row.closureReason] || "",
    },
    {
      field: "flag",
      headerName: "Follow-up",
      width: 170,
      cellClassName: (params) => (params.row.flag.length > 0 ? "flag-full-cell" : "flag-empty-cell"),
      renderCell: (params) => (
        <>
          <TextField
            variant="outlined"
            name={`flag`}
            defaultValue={params.row.flag}
            onBlur={(event) => setFlag(event, params.row.id, params.row.flag)}
            InputProps={{
              classes: {
                notchedOutline: classes.noBorder,
                input: params.row.flag.length > 0 ? "flag-full" : "flag-empty",
              },
            }}
            multiline
            maxRows={4}
            style={{ width: "100%" }}
            onFocus={(event) => {
              event.target.select();
            }}
          ></TextField>
        </>
      ),
    },
    {
      field: "closureFinalAssessmentStatus",
      headerName: "Final Assessment",
      width: 170,
      renderCell: (params) => {
        const link = params.row.closureFinalAssessmentLink;

        if (!link) {
          return params.value;
        }

        return <a href={link}>{params.value}</a>;
      },
    },
    {
      field: "closureSurveyStatus",
      headerName: "Survey",
      width: 150,
      renderCell: (params) => {
        const link = params.row.closureSurveyLink;

        if (!link) {
          return params.value;
        }

        return <a href={link}>{params.value}</a>;
      },
    },
    {
      field: "experienceResponse",
      headerName: "Experience Response",
      width: 340,
      renderCell: (params) => {
        const value = params.value || "";
        const displayValue = value.length > 200 ? `${value.substring(0, 200)}...` : value;

        return (
          <Tooltip title={value}>
            <span>{displayValue}</span>
          </Tooltip>
        );
      },
    },
    // { field: "closureExperienceRating", headerName: "Exp. Rating", width: 140 },
    // {
    //   field: "none",
    //   headerName: "Actions",
    //   width: 430,
    //   renderCell: (params) => (
    //     <>
    //       {params.row.adminClosureStatus === "Not Started" ? (
    //         <>
    //           <Tooltip title="Move to In Progress">
    //             <Button
    //               variant="secondary"
    //               size="sm"
    //               onClick={() => updateAdminClosureStatus(params.row, "In Progress")}
    //               style={{
    //                 color: "blue",
    //                 fontWeight: 500,
    //                 border: 0,
    //                 background: "#eee",
    //                 marginRight: 14,
    //               }}
    //             >
    //               Move to In Progress
    //             </Button>
    //           </Tooltip>
    //         </>
    //       ) : params.row.adminClosureStatus === "In Progress" ? (
    //         <>
    //           <Tooltip title="Close">
    //             <Button
    //               variant="secondary"
    //               size="sm"
    //               onClick={() => updateAdminClosureStatus(params.row, "Closed")}
    //               style={{
    //                 color: "green",
    //                 fontWeight: 500,
    //                 border: 0,
    //                 background: "#eee",
    //                 marginRight: 14,
    //               }}
    //             >
    //               Close
    //             </Button>
    //           </Tooltip>
    //         </>
    //       ) : params.row.adminClosureStatus === "Closed" ? (
    //         <>
    //           <Tooltip title="Reopen">
    //             <Button
    //               variant="secondary"
    //               size="sm"
    //               onClick={() => updateAdminClosureStatus(params.row, "In Progress")}
    //               style={{
    //                 color: "orange",
    //                 fontWeight: 500,
    //                 border: 0,
    //                 background: "#eee",
    //                 marginRight: 14,
    //               }}
    //             >
    //               Re Open
    //             </Button>
    //           </Tooltip>
    //         </>
    //       ) : null}
    //     </>
    //   ),
    // },
  ];

  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
  };

  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item>
          <h4 style={{ marginBottom: 12 }}>Closure Admin View</h4>
        </Grid>
      </Grid>

      <Paper>
        <Grid container style={{ padding: 10 }}>
          <Grid item style={{ paddingLeft: 2, paddingRight: 10 }}>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control type="text" placeholder="Search Clients" value={searchTerm} onChange={(event) => handleSearch(event)} autoComplete="OFF" />
            </InputGroup>
          </Grid>
          {/* filters.clientsPsychologist === 'All' ? 'All' :  */}
          <Grid item style={{ paddingRight: 10 }}>
            <Autocomplete
              id="searchCSCentre"
              variant="outlined"
              options={csCentres || []}
              getOptionLabel={(option) => ((filters.csCentre === "All" && !option.centerName) || !option.centerName ? "All" : option.centerName)}
              value={filters.csCentre}
              onChange={(event, newValue) =>
                dispatch(
                  Admin.actions.setFilters({
                    filterName: "csCentre",
                    filterValue: newValue ? newValue : "All",
                  }),
                )
              }
              style={{
                minWidth: 200,
                fullWidth: true,
                display: "flex",
                wrap: "nowrap",
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Centre"
                  type="text"
                  variant="outlined"
                  margin="dense"
                  name="CSCentreSelector"
                  style={{
                    backgroundColor: "white",
                    margin: 0,
                    padding: 0,
                    maxWidth: 200,
                  }}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "new-password",
                  }}
                />
              )}
            />
          </Grid>
          {/* <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl}>
              <InputLabel id="clientsClosureStatus-label" className={classes.label}>
                Closure Status
              </InputLabel>
              <Select
                labelId="clientsClosureStatus-label"
                id="clientsClosureStatus"
                margin="dense"
                style={{ minWidth: 120, backgroundColor: "#ffffff" }}
                value={filters.clientsClosureStatus}
                onChange={(event) =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "clientsClosureStatus",
                      filterValue: event.target.value,
                    }),
                  )
                }
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Not Started">Not Started</MenuItem>
                <MenuItem value="In Progress">In Progress</MenuItem>
                <MenuItem value="Closed">Closed</MenuItem>
              </Select>
            </FormControl>
          </Grid> */}
        </Grid>
      </Paper>

      {csClosuresAdmin ? (
        <Paper style={{ height: 700 }}>
          <DataGridPro rows={filteredCsClosures} columns={columns} checkboxSelection={false} rowHeight={40} />
        </Paper>
      ) : (
        "None"
      )}

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
